<label class="fx-row fx-flex-1 fx-align-center fx-justify-space-between"
  ><span>{{ option.body }}</span><ng-content></ng-content>
</label>
